/**
 * DrugManagement — wrapper page containing:
 *  - drug list (delegated back to Admin.jsx main list via `onBack` returning)
 *  - "Add drug" navigation
 *  - "Search analytics" nested page (SearchAnalytics.jsx reused)
 *
 * Kept lightweight: uses the existing SearchAnalytics page unchanged, and
 * routes the "Add drug" via react-router (existing /admin/add page).
 */
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Plus, Search as SearchIcon, PillBottle } from "lucide-react";
import SearchAnalytics from "@/pages/admin/SearchAnalytics";

export default function DrugManagement({ onBack, drugListSlot, me }) {
  const [showSearch, setShowSearch] = useState(false);
  const canView = me?.is_super_admin || (me?.permissions || []).includes("view_analytics");

  if (showSearch)
    return <SearchAnalytics onBack={() => setShowSearch(false)} />;

  return (
    <div data-testid="drug-management-panel" className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b-2 border-slate-900 pb-6">
        <div>
          <div className="text-sm font-bold text-slate-500 mb-2">دوائي / لوحة الإدارة</div>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-2">
            <PillBottle className="w-7 h-7" />إدارة الأدوية
          </h1>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/add" data-testid="dm-add-drug-btn"
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-bold px-4 py-3 rounded-xl cursor-pointer">
            <Plus className="w-4 h-4" /><span>إضافة دواء</span>
          </Link>
          {canView && (
            <button type="button" onClick={() => setShowSearch(true)} data-testid="dm-open-search-analytics-btn"
              className="inline-flex items-center gap-2 bg-slate-50 hover:bg-slate-100 text-slate-900 border-2 border-slate-200 font-bold px-4 py-3 rounded-xl cursor-pointer">
              <SearchIcon className="w-4 h-4" /><span>إحصائيات البحث عن الأدوية</span>
            </button>
          )}
          <button type="button" onClick={onBack} data-testid="dm-back-btn"
            className="inline-flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-900 font-bold px-4 py-3 rounded-xl cursor-pointer">
            <ArrowRight className="w-4 h-4" /><span>العودة إلى لوحة الأدمن</span>
          </button>
        </div>
      </div>
      {drugListSlot}
    </div>
  );
}
